const MONTHS: Record<string, number> = {
    jan: 1,
    january: 1,
    feb: 2,
    february: 2,
    mar: 3,
    march: 3,
    apr: 4,
    april: 4,
    may: 5,
    jun: 6,
    june: 6,
    jul: 7,
    july: 7,
    aug: 8,
    august: 8,
    sep: 9,
    sept: 9,
    september: 9,
    oct: 10,
    october: 10,
    nov: 11,
    november: 11,
    dec: 12,
    december: 12
};

const cleanValue = (value: string): string => {
    return value
        .trim()
        .replace(/^'+/, '')
        .replace(/\u00A0/g, ' ')
        .replace(/[‐-‒–—]/g, '-')
        .replace(/\s+/g, ' ');
};

const toYearToken = (value?: string): string | undefined => {
    if (!value) {
        return undefined;
    }

    const digits = value.replace(/\D/g, '');
    if (!digits) {
        return undefined;
    }

    return digits.length >= 2 ? digits.slice(-2) : digits.padStart(2, '0');
};

const tryParseMonthNameDate = (value: string, keepThreadSuffix: boolean): string | undefined => {
    let match = value.match(/^(\d{1,2})[-/ ]([A-Za-z]{3,9})(?:[-/ ](\d{2,4}))?$/);
    if (match) {
        const day = parseInt(match[1], 10);
        const month = MONTHS[match[2].toLowerCase()];
        const year = toYearToken(match[3]);

        if (month) {
            return keepThreadSuffix && year ? `${month}/${day}-${year}` : `${month}/${day}`;
        }
    }

    match = value.match(/^([A-Za-z]{3,9})[-/ ](\d{1,2})(?:[-/ ](\d{2,4}))?$/);
    if (match) {
        const month = MONTHS[match[1].toLowerCase()];
        const day = parseInt(match[2], 10);
        const year = toYearToken(match[3]);

        if (month) {
            return keepThreadSuffix && year ? `${month}/${day}-${year}` : `${month}/${day}`;
        }
    }

    return undefined;
};

const tryParseNumericDate = (value: string, keepThreadSuffix: boolean): string | undefined => {
    let match = value.match(/^(\d{1,4})[/-](\d{1,2})[/-](\d{1,4})$/);

    if (match) {
        let month: number;
        let day: number;
        let year: string;

        if (match[1].length === 4) {
            year = match[1];
            month = parseInt(match[2], 10);
            day = parseInt(match[3], 10);
        } else {
            year = match[3];

            const first = parseInt(match[1], 10);
            const second = parseInt(match[2], 10);

            if (first > 12 && second <= 12) {
                day = first;
                month = second;
            } else {
                month = first;
                day = second;
            }
        }

        if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
            const yearToken = toYearToken(year);
            return keepThreadSuffix && yearToken ? `${month}/${day}-${yearToken}` : `${month}/${day}`;
        }
    }

    match = value.match(/^(\d{1,2})\/(\d{1,2})$/);
    if (match) {
        const first = parseInt(match[1], 10);
        const second = parseInt(match[2], 10);

        const month = first > 12 && second <= 12 ? second : first;
        const day = first > 12 && second <= 12 ? first : second;

        if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
            return `${month}/${day}`;
        }
    }

    return undefined;
};

export const normalizeFilterSortValue = (rawValue?: string, keepThreadSuffix = false): string => {
    if (!rawValue) {
        return '';
    }

    const value = cleanValue(rawValue.toString());

    return tryParseMonthNameDate(value, keepThreadSuffix) || tryParseNumericDate(value, keepThreadSuffix) || value;
};

export const normalizeFilterSortKey = (rawValue?: string, keepThreadSuffix = false): string => {
    return normalizeFilterSortValue(rawValue, keepThreadSuffix).toLowerCase();
};
